import { render, staticRenderFns } from "./WarrantyList.vue?vue&type=template&id=65de1148&scoped=true"
import script from "./WarrantyList.vue?vue&type=script&lang=js"
export * from "./WarrantyList.vue?vue&type=script&lang=js"
import style0 from "./WarrantyList.vue?vue&type=style&index=0&id=65de1148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de1148",
  null
  
)

export default component.exports